export function getTopSkills(
  skills: string[],
  numberOfSkills: number = 8,
): string[] {
  const counts: Record<string, number> = {};

  for (const skill of skills) {
    counts[skill] = (counts[skill] ?? 0) + 1;
  }

  const sortedSkills = Object.entries(counts).sort(
    (a, b) => (b[1] as number) - (a[1] as number),
  );
  return sortedSkills.slice(0, numberOfSkills).map(([name]) => name);
}
